


































































import { Component, Prop, Vue } from 'vue-property-decorator'

import UiButton from '@/components/semantic-ui/Button'

import * as constants from '@/constants'

import { Brand, Category, Coupon, PantryItem } from '@/datastore/models'

import AddToShoppingListModal from '../modals/AddToShoppingListModal.vue'

import auth from '@/store/modules/auth'
import grocery from '@/store/modules/grocery'

@Component({
	components: {
		AddToShoppingListModal,
		UiButton,
	},
})
export default class PantryListItem extends Vue {

	$refs!: {
		'add-to-shopping-list-modal': AddToShoppingListModal
	}

	@Prop({ required: true })
	readonly category!: Category

	@Prop({ required: true })
	readonly item!: PantryItem

	isAddingCoupon = false

	isAddingToShoppingList = false

	get brandList(): string {

		return (grocery.pantryItemBrands[this.item.$id] ?? [])
			.map(b => grocery.brandsCollection[b])
			.filter((b): b is Brand => !!b)
			.map(b => b.name)
			.sort((a, b) => a.localeCompare(b))
			.join(', ')
	}

	get coupons(): Coupon[] {

		return grocery.coupons.filter(coupon => coupon.promoItems.some(item => item.pantryItemId === this.item.$id))
	}

	get isInShoppingList(): boolean {

		return grocery.shoppingListItems.some(i => i.pantryItemId === this.item.$id)
	}

	get user(): firebase.UserInfo | null {

		return auth.user
	}

	async doAddCoupon(): Promise<void> {

		this.isAddingCoupon = true

		const newCoupon = await grocery.addCoupon({
			description: '',
			promoItems: [{ pantryItemId: this.item.$id }],
			title: '',
		})

		this.isAddingCoupon = false

		this.$router.push({ name: 'coupon', params: { id: newCoupon.id } })
	}

	async doAddToShoppingList(): Promise<void> {

		const { notes, preferredBrands, quantity } = this.$refs['add-to-shopping-list-modal']

		this.isAddingToShoppingList = true

		await grocery.addShoppingListItem({
			createdAt: Date.now(),
			createdBy: this.user?.uid,
			name: this.item.name,
			notes,
			pantryItemId: this.item.$id,
			preferredBrands,
			quantity,
		})

		this.isAddingToShoppingList = false
	}

	mounted() {

		if (this.item.$id === sessionStorage.getItem(constants.sessionStorage.ACTIVE_PANTRY_ITEM_ID)) {
			Vue.nextTick(() => {
				setTimeout(() => {
					const absoluteElementTop = this.$el.getBoundingClientRect().top + window.pageYOffset
					const middle = absoluteElementTop - (window.innerHeight / 2)
					window.scrollTo({ behavior: 'smooth', top: middle })
				}, 100)
			})
		}
	}

	async onAddToShoppingList(): Promise<void> {

		this.$refs['add-to-shopping-list-modal'].show()
	}

	onClick(): void {

		sessionStorage.setItem(constants.sessionStorage.ACTIVE_PANTRY_ITEM_ID, this.item.$id)
		this.$router.push(`/item/${this.item.$id}`)
	}

}

